module.exports = __webpack_public_path__ + "static/media/dHunter.e92a0893.jpeg";